<template>
  <div style="margin: 16px 0;">
    <van-form @submit="onSubmit">
      <van-field v-model="addressInfo.name" label="姓名" placeholder="收货人姓名" :rules="[{ required: true }]" />
      <van-field v-model="addressInfo.mobile" label="电话" placeholder="收货人手机号"
        :rules="[{ required: true }, { pattern: mobilePattern, message: '请输入正确手机号' }]" />


      <van-field v-model="addressInfo.cityName" is-link readonly label="地区" placeholder="请选择所在地区" @click="show = true"
        :rules="[{ required: true }]" />
      <van-field v-model="addressInfo.address" label="详细地址" placeholder="街道、门牌号等信息" :rules="[{ required: true }]" />
      <van-field name="switch" label="设为默认">
        <template #input>
          <van-switch v-model="addressInfo.isDefault" size="20" />
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <div style="margin: 16px;">
      <van-button round block type="danger" @click="onDelete" v-if="addressId > 0">删除
      </van-button>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-cascader ref="fff" v-model="cascaderValue" title="请选择所在地区" :options="options"
        :field-names="{ text: 'areaName', value: 'areaId' }" @close="show = false" @change="onChange" @finish="onFinish" />
    </van-popup>

  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { Toast, Dialog } from "vant";
import { deleteAddress, getAddress, getJdAreaList, mall_WxUser_save_address } from "@/api/user";

export default {
  name: "address-edit",

  data() {
    return {
      addressId: '',
      areaList,
      addressInfo: { isDefault: true },
      show: false,
      fieldValue: '',
      cascaderValue: '',
      options: [],
      n1: {},
      n2: {},
      n3: {},
      mobilePattern: /^1[3456789]\d{9}$/
    };
  },

  created() {
    getJdAreaList().then(res => {
      budo_log.info("#59 getJdAreaList", res)

      if(res.code > 0 ) {
        Dialog.alert({ message: res.msg || "获取地区失败" })
        return
      }

      this.options = res.data.map(area => {
        area.children = [];
        return area;
      });
    });

    this.addressId = this.$route.query.addressId;

    if (this.addressId > 0) {
      getAddress(this.addressId).then(res => {
        this.addressInfo = res.data;
      })
    }
  },

  methods: {
    onSubmit(values) {
      budo_log.info("#88 onSubmit", this.addressInfo, values)

      this.addressInfo.isDefault = this.addressInfo.isDefault ? 1 : 0;

      mall_WxUser_save_address(this.addressInfo).then(res => {
        if (res.code === 0) {
          Toast({ message: '保存地址成功' })

          this.$store.dispatch("GetDefaultAddress").then(() => {
            this.$router.go(-1);
          });
        } else {
          Toast({ message: '保存地址失败：' + res.msg, duration: 5000 })
        }
      })
    },

    onChange({ value, selectedOptions, tabIndex }) {
      getJdAreaList(value, tabIndex + 2).then(res => {
        budo_log.info("#95 getJdAreaList", res)
        if(res.code > 0 ) {
          Dialog.alert({ message: res.msg || "获取地区失败" })
          return
        }

        let destNode = null;
        for (const opt in selectedOptions) {
          if (tabIndex === 0) {
            this.n1 = this.options.find(o => o.areaId === value);
            destNode = this.n1;
          } else if (tabIndex === 1) {
            this.n2 = this.n1.children.find(o => o.areaId === value);
            destNode = this.n2;
          } else if (tabIndex === 2) {
            this.n3 = this.n2.children.find(o => o.areaId === value);
            destNode = this.n3;
          } else if (tabIndex === 3) {
            destNode = this.n3.children.find(o => o.areaId === value);
          }
        }
        if (res.data && res.data.length > 0) {
          destNode.children = [...res.data.map(area => {
            area.children = [];
            return area;
          })];
        } else {
          this.onFinish({ selectedOptions: selectedOptions });
        }
      });
    },
    onFinish({ selectedOptions }) {
      this.show = false;
      this.addressInfo.cityName = selectedOptions.map((option) => option.areaName).join(' ');
      this.addressInfo.jdAreaCode = selectedOptions.map((option) => option.areaId).join(',');
    },
    onDelete() {
      deleteAddress(this.addressId).then(res => {
        Toast({ message: '删除成功' })
        this.$router.go(-1);
      })
    }
  },
}
</script>

<style scoped></style>
